import { gql } from '@apollo/client';
import IconArrowRight from '@apollo/icons/default/IconArrowRight.svg';
import React from 'react';
import { useLocation } from 'react-router';

import { useInternalGraphLinking } from 'src/app/graph/hooks/useInternalGraphLinking';
import { ConditionalLink } from 'src/components/conditionalLink/ConditionalLink';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import {
  getLinkToWorkflow,
  getLinkToWorkflowFragment,
} from '../../helpers/getLinkToWorkflow';
import {
  TaskStatusIcon,
  TaskStatusIconTaskFragment,
} from '../../taskStatusIcon/TaskStatusIcon';

export const SuccessfulCheckWorkflowItemFragment = gql`
  fragment SuccessfulCheckWorkflowItemFragment on CheckWorkflow {
    id
    tasks {
      id
      ...TaskStatusIconTaskFragment
    }
    ...getLinkToWorkflowFragment
  }
  ${getLinkToWorkflowFragment}
  ${TaskStatusIconTaskFragment}
`;

export const SuccessfulCheckWorkflowItem = ({
  workflow,
}: {
  workflow: GraphQLTypes.SuccessfulCheckWorkflowItemFragment;
}) => {
  const internalGraphLinking = useInternalGraphLinking();
  const location = useLocation();
  return (
    <ConditionalLink
      to={getLinkToWorkflow(workflow, location, internalGraphLinking)}
    >
      <div className="group flex items-center justify-between rounded px-2 py-1 hover:bg-secondary">
        <div className="flex items-center">
          <TaskStatusIcon
            className="size-4"
            task={GraphQLTypes.CheckWorkflowTaskStatus.PASSED}
          />
          <p className="ml-2 text-base text-secondary">All tasks succeeded!</p>
        </div>
        <IconArrowRight className="invisible text-placeholder group-hover:visible" />
      </div>
    </ConditionalLink>
  );
};
